import { render, staticRenderFns } from "./multipleDetail.vue?vue&type=template&id=752faf90&"
import script from "./multipleDetail.vue?vue&type=script&lang=js&"
export * from "./multipleDetail.vue?vue&type=script&lang=js&"
import style0 from "./multipleDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports